export function Avatar({ name, photo, size = 40 }: { name?: string; photo?: string; size?: number }) {
  const initial = (name?.trim() || '?').charAt(0).toUpperCase();
  if (photo) {
    return (
      <img
        src={photo}
        alt={name || ''}
        style={{ width: size, height: size }}
        className="rounded-full object-cover bg-slate-200"
      />
    );
  }
  return (
    <div
      style={{ width: size, height: size }}
      className="rounded-full bg-brand-50 text-brand grid place-items-center font-bold"
    >
      {initial}
    </div>
  );
}
